<template>
    <div class="TemplateTab p-3">
        <div class="SearchArea">
            <input type="search" class="form-control rounded-pill h-45px" placeholder="Search ... " />
        </div>
        <div class="imagsGallery stickers-container">
            <!-- <h5 class="text-muted py-2">Recent Stickers</h5>
            <a href="javascript:;" >Error : Failed To Load Stickers unknown IP Address</a> -->
            <div v-for="(item, index) in filteredStickers" :key="index">
                <div class="mt-6 d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-widest text-left py-3 mb-0">
                        {{ item.category }}
                    </label>
                    <svg @click="showStickersOfCategory(item.category)" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" xmlns="http://www.w3.org/2000/svg" class="text-blue-600 cursor-pointer ml-2">
                        <g clip-path="url(#clip0_4440_677)">
                            <path v-if="activeCategory !== item.category"
                                d="M3 11H17.17L13.59 7.41L15 6L21 12L15 18L13.59 16.59L17.17 13H3V11Z" fill="#4263EB">
                            </path>
                            <path v-else d="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z"
                                fill="#4263EB">
                            </path>
                        </g>
                        <defs>
                            <clipPath id="clip0_4440_677">
                                <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="row bg-light ml-1 mr-1">
                    <div v-for="(path, idx) in item.childrens" :key="idx"
                        :class="`${activeCategory !== null ? 'col-md-6' : 'col-md-4'} mb-2 mt-2 h-80px`">
                        <div class="flex-auto m-1 min-w-0 h-full relative">
                            <a href="javascript:;" class="column" v-bind:key="idx" :draggable="true"
                                @dragstart="dragElement($event, getImageUrl(item.category, path)[0])"
                                @click="addImageinCanvas(getImageUrl(item.category, path)[0], index)">
                                <img crossorigin="anonymous" class="img-fluid w-100"
                                    v-for="(imgUrl, imgIdx) in getImageUrl(item.category, path)" :src="imgUrl"
                                    :key="imgIdx" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Stickers } from "../../commonJSON";
import { v4 as uuidv4 } from 'uuid';
export default {
    name: "StickersTab",
    data() {
        return {
            stickers: Stickers,
            activeCategory: null,
        };
    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
        filteredStickers() {
            if (this.activeCategory) {
                return this.stickers.filter(item => item.category === this.activeCategory);
            } else {
                return this.stickers.map(item => {
                    return {
                        ...item,
                        childrens: item.childrens.slice(0, 3),
                    };
                });
            }
        },
    },
    methods: {
        showStickersOfCategory(category) {
            if (this.activeCategory === category) {
                this.activeCategory = null;
            } else {
                this.activeCategory = category;
            }
        },
        getImageUrl(category, path) {
            const svgUrl = `/stickers/${category}/${path}.svg`;
            const pngUrl = `/stickers/${category}/${path}.png`;
            return [svgUrl, pngUrl];
        },
        dragElement(e, link) {
            let obj = {
                id: `Stickers_${uuidv4()}`,
                type: 'stickers',
                // top:250,
                // left:150,
                rotate: 0,
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
                zoom: 1,
                // width:150,
                // height:100,
                svgColor: "",
                width: this.getActiveCanvas.size.width,
                height: this.getActiveCanvas.size.height,
                opacity: 1,
                lock: false,
                borderRadius: 0,
                url: link,
                brightness: 100,
                contrast: 100,
                saturation: 100,
                animationClassIn: "",
                animationClassOut: "",
                animationClassLoop: "",
                animationClass: "",
                animationDelay: 0,
                animationDuration: 2,
                animationDelayIn: 0,
                animationDurationIn: 2,
                animationDelayOut: 0,
                animationDurationOut: 2,
                animationLoopDuration: 2,
                orientation: 0,
                adjustment: 'cover',
                animationLoop: false
            };
            var j = JSON.stringify(obj);
            e.dataTransfer.setData("imgs", j);
        },
        async addImageinCanvas(link) {
            const stickerWidth = 250;
            const stickerHeight = 250;
            const canvas = this.getActiveCanvas;
            const canvasWidth = canvas.size.width;
            const canvasHeight = canvas.size.height;
            const left = (canvasWidth - stickerWidth) / 2;
            const top = (canvasHeight - stickerHeight) / 2;
            const res = await fetch(link);
            let svgText = await res.text();

            this.$store.dispatch("addObjectInCanvas",
                {
                    id: `Stickers_${uuidv4()}`,
                    type: 'stickers',
                    top,
                    left,
                    rotate: 0,
                    scaleX: 1,
                    scaleY: 1,
                    zoom: 1,
                    width: stickerWidth,
                    height: stickerHeight,
                    // width: this.getActiveCanvas.size.width,
                    // height: this.getActiveCanvas.size.height,
                    opacity: 1,
                    lock: false,
                    borderRadius: 0,
                    svgContent: svgText,
                    svgColor: '',
                    url: link,
                    brightness: 100,
                    contrast: 100,
                    saturation: 100,
                    isInAnimationActive: false,
                    isOutAnimationActive: false,
                    isLoopAnimationActive: false,
                    AnimationSequence: [],
                    animationClassIn: "",
                    animationClassOut: "",
                    animationClass: "",
                    animationClassLoop: "",
                    animationDelay: 0,
                    animationDuration: 2,
                    animationDelayIn: 0,
                    animationDurationIn: 2,
                    animationDelayOut: 0,
                    animationDurationOut: 2,
                    animationLoopDuration: 2,
                    orientation: 0,
                    adjustment: 'cover',
                    animationLoop: false
                },
            )
        }
    }
}
</script>
<style scoped>
.h-45px {
    height: 45px;
}

.imagsGallery h5 {
    letter-spacing: .1em;
    font-size: 15px;
}

.TemplateTab {
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
}

.SearchArea {
    flex-shrink: 0;
    margin-bottom: 1rem;
}

.stickers-container {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
}
</style>